import React from 'react'
import Manager from '../../public/components/Manager'
import LeaveApplyDetail from './LeaveApplyDetail'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        当年: {
            export: true,
            exportColumns: [
                { _text: '申请编号', minWidth: 250, search: true, },
                { _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
                { _datetime: '开始时间', minWidth: 200, filter: true, align: 'left' },
                { _datetime: '结束时间', minWidth: 200, filter: true, align: 'left' },
                { _text: '职务代理人', minWidth: 200, search: true, },
                { _text: '申请人', minWidth: 200, search: true, },
                { _text: '申请部门', field: '_ApplyDep', minWidth: 150, search: true, flex: 10, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
                { _text: '状态名称', minWidth: 200, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            buttons: [
            ],
            columns: [
                { _text: '申请编号', minWidth: 250, search: true, },
                { _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
                { _datetime: '开始时间', minWidth: 200, filter: true, align: 'left' },
                { _datetime: '结束时间', minWidth: 200, filter: true, align: 'left' },
                { _text: '职务代理人', minWidth: 200, search: true, },
                { _text: '申请人', minWidth: 200, search: true, },
                { _text: '申请部门', minWidth: 150, search: true, flex: 10, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
                { _text: '状态名称', minWidth: 200, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <LeaveApplyDetail {...props} id={data.id} readOnly={true} />)
            }
        },
        全部: {
            export: true,
            exportColumns: [
                { _text: '申请编号', minWidth: 250, search: true, },
                { _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
                { _datetime: '开始时间', minWidth: 200, filter: true, align: 'left' },
                { _datetime: '结束时间', minWidth: 200, filter: true, align: 'left' },
                { _text: '职务代理人', minWidth: 200, search: true, },
                { _text: '申请人', minWidth: 200, search: true, },
                { _text: '申请部门', field: '_ApplyDep', minWidth: 150, search: true, flex: 10, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
                { _text: '状态名称', minWidth: 200, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            buttons: [
            ],
            columns: [
                { _text: '申请编号', minWidth: 250, search: true, },
                { _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
                { _datetime: '开始时间', minWidth: 200, filter: true, align: 'left' },
                { _datetime: '结束时间', minWidth: 200, filter: true, align: 'left' },
                { _text: '职务代理人', minWidth: 200, search: true, },
                { _text: '申请人', minWidth: 200, search: true, },
                { _text: '申请部门', minWidth: 150, search: true, flex: 10, renderer: v => v ? v.split('/')[v.split('/').length - 1] : '' },
                { _text: '状态名称', minWidth: 200, search: true, filter: ['select'], },
                { _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <LeaveApplyDetail {...props} id={data.id} readOnly={true} />)
            }
        }
    }
}

export default props => <Manager {...props} config={config} />